import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { SimpleGrid, Loader, Box } from '@mantine/core'
import { AppModal, AppText, ProfileUserAvatar } from '../../app/common/ui'
import { Profile } from '../../app/models/profile'
import { useStore } from '../../app/stores/store'

interface Props {
  username: string;
  opened: boolean;
  onClose: () => void;
  mode: 'followers' | 'following';
}

export default observer(function FollowersModal ({ username, opened, onClose, mode }: Props) {
  const { profileStore } = useStore()
  const history = useHistory()
  const [list, setList] = useState<Profile[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!opened || !username) return
    setLoading(true);
    (mode === 'followers' ? profileStore.loadFollowers(username) : profileStore.loadFollowing(username))
      .then((data) => setList(data))
      .catch(() => setList([]))
      .finally(() => setLoading(false))
  }, [opened, username, mode, profileStore])

  const goToProfile = (target: string) => {
    onClose()
    history.push(`/profiles/${target}`)
  }

  return (
    <AppModal
      opened={opened}
      onClose={onClose}
      title={mode === 'followers' ? 'Followers' : 'Following'}
      size="md"
    >
      {loading
        ? (
        <Box py="xl" sx={{ display: 'flex', justifyContent: 'center' }}>
          <Loader size="sm" />
        </Box>
          )
        : list.length === 0
          ? (
        <AppText color="dimmed" size="sm" py="xl">
          {mode === 'followers' ? 'No followers yet' : 'Not following anyone yet'}
        </AppText>
            )
          : (
        <SimpleGrid cols={1} spacing="sm">
          {list.map((p) => (
            <Box
              key={p.username}
              onClick={() => goToProfile(p.username)}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                padding: 'var(--gs-xs)',
                borderRadius: 8,
                cursor: 'pointer',
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.04)' }
              }}
            >
              <ProfileUserAvatar
                variant="row"
                size={40}
                imageUrl={p.image}
                displayName={p.displayName}
                username={p.username}
                tier={p.ammoTier}
              />
              <Box sx={{ minWidth: 0 }}>
                <AppText size="sm" weight={600} lineClamp={1}>
                  {p.displayName || p.username}
                </AppText>
                <AppText size="xs" color="dimmed">
                  @{p.username}
                </AppText>
              </Box>
            </Box>
          ))}
        </SimpleGrid>
            )}
    </AppModal>
  )
})
